import React from 'react';
import { ConnectionProps, ConnectionWidget } from '@/views/settings/connections/Connections.widget';
import { useTranslation } from 'react-i18next';

export default function Connections() {
  const { t } = useTranslation();

  const data: ConnectionProps[] = [
    {
      title: 'Metamask',
      provider: 'wallet',
      icon: 'metamask',
      description: t('To perform on-chain tasks and receive daily-reward, connect your Metamask'),
      account: null /* TODO: profile.wallet */,
    },
    {
      title: 'Twitter',
      provider: 'twitter',
      description:
        'To stay up-to-date with the latest community news and earn daily-reward by completing tasks, connect your Twitter.',
      account: null /* TODO: profile.twitter */,
    },
    {
      title: 'Telegram',
      provider: 'telegram',
      description: 'Sign up to our Telegram channel. Get instant notification of the latest news.',
      account: null /* TODO: profile.telegram */,
    },
    {
      title: 'Discord',
      provider: 'discord',
      description: 'Sign up to our Discord channel. Get instant notification of the latest news.',
      account: null /* TODO: profile.discord */,
    },
    {
      title: 'Github',
      provider: 'github',
      description: 'To perform development tasks and receive daily-reward, connect your Github',
      account: null /* TODO: profile.github */,
    },
    // {
    //   title: 'Google',
    //   provider: 'google',
    //   description: 'To perform development tasks and receive daily-reward, connect your Google',
    //   account: null /* TODO: profile.google */,
    // },
    {
      title: 'Steam',
      provider: 'steam',
      description: 'To perform development tasks and receive daily-reward, connect your Steam',
      account: null /* TODO: profile.steam */,
    },
    {
      title: 'Spotify',
      provider: 'spotify',
      description: 'To perform development tasks and receive daily-reward, connect your Spotify',
      account: null /* TODO: profile.steam */,
    },
    {
      title: 'Reddit',
      provider: 'reddit',
      description: 'To perform development tasks and receive daily-reward, connect your Reddit',
      account: null /* TODO: profile.reddit */,
    },
  ];
  return (
    <div className='flex flex-col gap-y-8 w-full'>
      <h3 className='text-xl leading-7 font-bold ml-1 text-center md:text-left dark:text-white'>
        {t('Connect Accounts')}
      </h3>
      <div className='flex flex-wrap w-full flex-initial -mx-1 gap-y-4'>
        {data.map((i, k) => (
          <ConnectionWidget key={k} {...i} />
        ))}
      </div>
    </div>
  );
}
